/* @flow */

import Company from 'models/companies/company';
import RegisterSellerCompanyRequest from 'models/requests/isos/registerSellers/registerSellerCompanyRequest';
import IncompleteAlertRequest from 'models/requests/register/incompleteAlertRequest';

export default class RegisterSellerCompanyForm {
  company: Company;

  lastName: string;
  firstName: string;
  email: string;
  mobile: string;
  mobilePresence: string;
  functionName: string;
  languageId: number;

  constructor() {
    this.country = null;
    this.company = null;

    this.lastName = '';
    this.firstName = '';
    this.email = '';
    this.mobile = '';
    this.mobilePresence = '';
    this.functionName = '';
    this.languageId = 0;
  }

  toRequest(isoCompanyId: number) {
    const request = new RegisterSellerCompanyRequest();
    request.isoCompanyId = isoCompanyId;
    request.insurerId = this.company.insurerId;

    request.lastName = this.lastName;
    request.firstName = this.firstName;
    request.email = this.email;
    request.mobile = this.mobilePresence.length > 1 ? this.mobilePresence : this.mobile;
    request.functionName = this.functionName;
    request.languageId = this.languageId;
    return request;
  }

  toIncompleteAlertRequest(isoCompanyId: number, flow: string) {
    const request = new IncompleteAlertRequest();
    request.companyType = 1;
    request.insurerId = this.company?.insurerId;
    request.companyName = this.company?.name;
    request.countryId = this.company?.countryId;
    request.postalCode = this.company?.zipCode;
    request.city = this.company?.city;
    request.phone = this.company?.phone;
    request.vatNumber = this.company?.vatNumber;
    request.isoCompanyId = isoCompanyId;
    
    request.firstName = this.firstName;
    request.lastName = this.lastName;
    request.email = this.email;
    request.mobile = this.mobilePresence?.length > 1 ? this.mobilePresence : this.mobile;
    request.languageId = this.languageId;
    request.functionName = this.functionName;
    
    request.requestFlow = flow;
    
    return request;
  }
}
